import { Component, HostBinding, OnDestroy, OnInit } from '@angular/core';
import { MatCheckboxChange } from '@angular/material';
import { CurrentService, ElementsService, ProjectService, fullApiPath } from 'dbweb-core';
import { Subscription } from 'rxjs';
import { exportAnimation } from './animal';
import { ExportService, ExportTaskWSMessage } from './export.service';

@Component({
	selector: 'common-export',
	templateUrl: './export.component.html',
	styleUrls: ['./export.component.scss'],
	animations: [exportAnimation],
	providers: [ExportService]
})
export class ExportComponent implements OnInit, OnDestroy {
	@HostBinding('class.export') hostClass = true;
	subs: Subscription[] = [];

	constructor(
		public svr: ExportService,
		public prj: ProjectService,
		private eles: ElementsService,
		private cur: CurrentService
	) {}

	ngOnInit() {
		this.svr.init();
	}
	ngOnDestroy() {
		this.subs.forEach(v => v.unsubscribe());
	}

	selectChecked(event: MatCheckboxChange) {
		this.svr.columns.forEach(v => (v.selected = event.checked));
	}
	doExport() {
		this.svr
			.doExport({
				Format: this.svr.format,
				DB: this.svr.dbName,
				TableName: this.svr.tableName,
				Encoding: this.svr.encoding,
				Columns: this.svr.columns.filter(v => v.selected).map(v => v.Name)
			})
			.subscribe(v => {
				this.svr.step = 'inTheExpord';
				const startTime = new Date();
				this.svr.taskInfoURL = this.prj.frontURL('task', v.TaskInfoURL);
				this.svr.zipFileURL = fullApiPath(v.ZipFileSignURL);
				this.subs.push(
					this.cur.wsCtrl.observable.subscribe((mes: ExportTaskWSMessage) => {
						if (mes.Data.TaskID === v.TaskID) {
							if (!mes.Data.Completed) {
								const g = mes.Data.Data / this.svr.rowCount;
								this.svr.exportProgress = g * 100;
								const d = new Date().getTime() - startTime.getTime();
								this.svr.timeRemaining = (d / g) * (1 - g);
							} else {
								this.svr.exportProgress = 100;
								this.svr.step = 'complete';
							}
						}
					})
				);
			});
	}
	chineseString(type: string) {
		if (type === 'STR') {
			return 'å­ç¬¦ä¸²';
		} else if (type === 'INT') {
			return 'æ´å';
		} else if (type === 'DATE') {
			return 'æ¥æ';
		} else if (type === 'FLOAT') {
			return 'æµ®ç¹';
		} else if (type === 'BYTEA') {
			return 'äºè¿å¶';
		}
	}
}
